module.exports = __webpack_public_path__ + "static/museum-3e7b9d1db86cf7b48883a923f8d4b464.jpeg";